import React from "react";
import "../../../css/TotalAgeSubsc.css";
import { PieChart, Pie, Tooltip, ResponsiveContainer } from "recharts";

interface TotalAgeSubscProps {
  TotalAgeSubsc: { age_group: string; subsc: number }[];
}

const TotalAgeSubsc = ({ TotalAgeSubsc }: TotalAgeSubscProps) => {
  return (
    <div className="age_container">
      <h2 className="age_total_title">年齢別登録者割合(累計)</h2>
      <ResponsiveContainer width="100%" height="75%">
        <PieChart className="Piechart">
          <Pie
            data={TotalAgeSubsc}
            dataKey="subsc"
            nameKey="age_group"
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#82ca9d"
            label
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TotalAgeSubsc;
